import { Outlet } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { SlidingPlayerContainer } from '../player/player_new.tsx';
import { PlayerContextProvider } from '../player/player_util.tsx';
import { useSetSongIslandPlaylist } from '../player/use_set_song_island_playlist.tsx';
import { useSelectUser } from '../util/use_select_user.tsx';
import { useServiceWorkerHelper } from '../util/use_service_worker_helper.tsx';
import useWindowDimensions from '../util/useWindowDimensions.ts';
import { useDisplayDemoPage } from './onboarding/use_display_demo_page.tsx';
import { ProfileDrawer } from './profile_drawer/profile_drawer.tsx';

export const Root = () => {
  const windowDimensions = useWindowDimensions();

  // hooks that navigate to other pages under certain conditions
  useDisplayDemoPage();
  useSetSongIslandPlaylist();
  useServiceWorkerHelper();
  useSelectUser();

  return (
    <>
      <GlobalStyles $windowHeight={windowDimensions.height} $windowWidth={windowDimensions.width} />
      <RootWrapper>
        <Outlet />
        <PlayerContextProvider>
          <SlidingPlayerContainer />
        </PlayerContextProvider>
        <ProfileDrawer />
      </RootWrapper>
    </>
  );
};

const GlobalStyles = createGlobalStyle<{ $windowHeight: number; $windowWidth: number }>`
  * {
    --view-height: ${(props) => props.$windowHeight}px;
    --view-width: ${(props) => props.$windowWidth}px;
  }
`;

const RootWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`;
